import React from "react";
import { Select, Input, Row, Col } from "antd";

const { Option } = Select;

const SearchFilters = ({ onStatusChange, onIdSearch }) => {
  return (
    <div style={{ width: "100%", marginBottom: "20px" }}>
      <Row gutter={24}>
        {/* Filter by Status */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Select
            placeholder="Filter by Status"
            onChange={onStatusChange}
            style={{ width: "100%", textAlign: "left" }}
            allowClear>
            <Option value="Open">Open</Option>
            <Option value="In Progress">In Progress</Option>
            <Option value="Resolved">Resolved</Option>
          </Select>
        </Col>

        {/* Filter by Ticket ID */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Input
            placeholder="Search by Ticket ID"
            allowClear
            enterButton="Search"
            onSearch={onIdSearch}
            style={{ width: "100%", textAlign: "left" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SearchFilters;
